<script setup lang="ts">
import { useKeycloak } from '@nxtpeople/nxt-vue-keycloak';
import { useLoadingScreen, useWindowScaling, setZoomLevel } from '@nxtpeople/nxt-styles';
import { ModuleKey } from '@nxtpeople/nxt-vue-library';

//#region if OS is set to >=125% scaling, set web-app scaling to 90% to compensate
setZoomLevel(1);
useWindowScaling(1.25, 0.9);
//#endregion

//#region Loading Screen
const { isPending } = useKeycloak();
const { showLoadingScreen, animationComplete } = useLoadingScreen(isPending);
//#endregion
</script>

<template>
   <RouterView v-slot="{ Component }">
      <transition name="fade" mode="out-in">
         <NxtLoadingScreen v-if="showLoadingScreen" :module-key="ModuleKey.NxtMatch" @animation-complete="animationComplete = true" />
         <component :is="Component" v-else />
      </transition>
   </RouterView>
</template>

<style src="@nxtpeople/nxt-styles/dist/style.css"></style>

<style lang="scss">
// Global styles, imported once. Must stay after the nxt-styles style.css import
// above so the :root overrides in base.scss (e.g. --nxt-main) win the cascade.
@import './scss/base.scss';

#app {
   height: 100%;
}

//BOOTSTRAP
@import '../node_modules/bootstrap/scss/_functions';
@import '../node_modules/bootstrap/scss/_variables';
@import '../node_modules/bootstrap/scss/_variables-dark';
@import '../node_modules/bootstrap/scss/_maps';
@import '../node_modules/bootstrap/scss/_mixins';
@import '../node_modules/bootstrap/scss/_root';
@import '../node_modules/bootstrap/scss/bootstrap-grid';
@import '../node_modules/bootstrap/scss/bootstrap-utilities';
</style>
